import './tabNavigator.css'

/*const isSelected = (currentNav, nav) => {

    const productList = ["category","promotion","clearance","orderEntry"];

    if(nav === "checkout" && currentNav === nav) {
        return true;
    } else if(nav === "account" && (currentNav === "account" || currentNav === "vendor")) {
        return true;
    } else if(nav === "products" && productList.includes(currentNav)) {
        return true;
    } else if(nav === "home" && !isSelected(currentNav, "products") &&
        !isSelected(currentNav, "account") && !isSelected(currentNav, "checkout")) {
        return true;
    }
    return false;
}
*/
// const TabNavigator = () => {
//
//     const location = useLocation();
//     const pathName = location.pathname;
//     const currentNav = pathName.split("/")[1];
//
//
//     return (
//         // <div className="tab-navigator-container">
//         <>
//             <div style={{ height: 60 }}/>
//             <div className="tab-navigator">
//                 <TabNavigatorButton
//                     name="Home"
//                     selected={isSelected(currentNav, "home")}
//                     nav="/"
//                 />
//                 <TabNavigatorButton
//                     name="Products"
//                     selected={isSelected(currentNav, "products")}
//                 />
//                 <TabNavigatorButton
//                     name="Checkout"
//                     selected={isSelected(currentNav, "checkout")}
//                     nav="/checkout"
//                 />
//                 <TabNavigatorButton
//                     name="Account"
//                     selected={isSelected(currentNav, "account")}
//                     nav="/account"
//                 />
//             </div>
//         </>
//     )
//
// }

const TabNavigator = () => {


    return (
        <></>
    )

}

export default TabNavigator;
